module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"support_ticket_status":{"All":"Todos","Open":"Aberto","Waiting":"Aguardando","Closed":"Fechado","Archived":"Arquivado"}},"en":{"support_ticket_status":{"All":"All","Open":"Open","Waiting":"Waiting","Closed":"Closed","Archived":"Archived"}}}')
  delete Component.options._Ctor
}
